/*    
 *  _________________________________________
 * / Stop right there, ya dingus. This file  \
 * \ should not be edited.                   /
 *  -----------------------------------------
 *  \
 *   \
 *      __
 *     /  \
 *     |  |
 *     @  @
 *     |  |
 *     || |/
 *     || ||
 *     |\_/|
 *     \___/
 *    
 * This file is automatically generated through https://localise.biz.
 *                                                                         
 * To update this file:
 *
 *  $ npm run update-language
 *
 * Last update:    Wed Jan 22 2025 15:40:47 GMT+0100 (Central European Standard Time)
 * Language keys:  2
 * Language code:  nl
 *
 */

const language = {
  "button": {
    "continue": "Doorgaan"
  },
  "component": {
    "questionNumber": {
      "questionNumberCurrent": "Vraag %{numberCurrent}",
      "questionNumberMax": "van %{numberMax}",
      "optional": " (Optioneel)"
    },
    "textInputBox": "Ik wil nog toevoegen...",
    "answerType": {
      "button": {
        "finishTheSurvey": "Vul de enquête in",
        "continue": "Doorgaan"
      }
    },
    "finishSurveyDisplay": {
      "thanks": "Bedankt voor je feedback!",
      "explanation": "Dit helpt ons enorm om uw veiligheid te blijven verbeteren."
    },
    "alert": {
      "error": "Er is een fout opgetreden tijdens het updaten van uw antwoorden. Probeer het opnieuw."
    },
    "loading": {
      "loading": "Bezig met laden...",
      "cannotOpen": "We kunnen de enquête niet openen.",
      "openSurveyAgain": "Sluit het tabblad en open de enquête opnieuw. Als het probleem zich blijft voordoen, neem dan contact op met support."
    }
  }
} as const

export default language